import { useMutation } from "@tanstack/react-query";
import { apiPost } from "../utils/fetch";
import { CREATE_CHECKOUT_SESSION_ENDPOINT } from "../constants/backendRoutes";

interface CreateCheckoutSessionPayload {
  successUrl: string;
  cancelUrl: string;
}

interface CreateCheckoutSessionResponse {
  sessionId: string;
  checkoutUrl: string;
}

const createCheckoutSession = async (payload: CreateCheckoutSessionPayload): Promise<CreateCheckoutSessionResponse> => {
  const response = await apiPost<CreateCheckoutSessionResponse>(CREATE_CHECKOUT_SESSION_ENDPOINT, payload);
  return response;
};

export const useCreateCheckoutSession = () => {
  return useMutation<CreateCheckoutSessionResponse, Error, CreateCheckoutSessionPayload>({
    mutationFn: createCheckoutSession,
  });
};
